import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import {
  GeneralConfirmationModalComponent
} from "../../../components/general-confirmation-modal/general-confirmation-modal.component";
import { GeneralConfirmationModalData, GeneralConfirmationModalResult } from "../../../models";
import { LoadingService } from "../../../services/loading.service";
import { ApiHttpService } from "../../../services/api-http.service";
import { DialogService } from "../../../services/dialog.service";

@Component({
  selector: 'cpf-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactUsComponent {
  @Output() accountViewClicked = new EventEmitter<void>();
  @Output() vouchersClicked = new EventEmitter<void>();

  reasonList = [{ value: "Dokumente", label: "" },
    { value: "Vertragsänderung", label: "" },
    { value: "Vertragskündigung", label: "" },
    { value: "Versicherungsberatung", label: "" },
    { value: "Lob & Kritik", label: "" },
  ];

  selectedReason = "";
  message = "";


  constructor(private router: Router,
              private translate: TranslateService,
              private dialog: MatDialog,
              private loadingService: LoadingService,
              private apiHttpService: ApiHttpService,
              private dialogService: DialogService,) {
    this.reasonList.forEach(reason => {
      this.translate.get(`contact-us.reasons.${reason.value}`).subscribe(
        (translation: string) => {
          reason.label = translation;
        }
      );
    })
  }

  navigateAccount() {
    if (this.accountViewClicked.observed) {
      this.accountViewClicked.emit();
      return;
    }
    this.router.navigate(['calingo', 'account', 'view']);
  }

  navigateVouchers() {
    if (this.vouchersClicked.observed) {
      this.vouchersClicked.emit();
      return;
    }
    this.router.navigate(['calingo', 'account', 'vouchers']);
  }

  sendContactUs() {
    const loadingRef = this.loadingService.open();

    try {
      this.apiHttpService.contactUs({ reason: this.selectedReason, text: this.message })
    } catch (e) {
      console.log('Error sending contact us request')
    } finally {
      loadingRef.close();
    }

    this.translate.get(['contact-us.modal.title', 'contact-us.modal.message']).subscribe(
      translations => {
        const dialogRef = this.dialogService.openDialog(GeneralConfirmationModalComponent, {
          data: {
            title: translations['contact-us.modal.title'],
            message: translations['contact-us.modal.message'],
            confirmButton: GeneralConfirmationModalResult.Confirm
          } as GeneralConfirmationModalData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === GeneralConfirmationModalResult.Confirm) {
            this.router.navigate(['calingo', 'account', 'view']);
          }
        });
      }
    )
  }
}
